import styled from "styled-components"
import { Row } from "react-bootstrap"

export const WorkshopCardDiv = styled.div`
  color: #1b1b1b;
  border-radius: 5px;
  cursor: pointer;
  & img{
    height: 150px;
  }
  @media (max-width: 767px) {
  }
  @media (max-width: 576px) {
    & img{
      height: auto;
    }
  }
  @media (max-width: 410px) {
  }
`

export const WorkshopDetailCardDiv = styled.div`
  color: #9a9a9a;
  border-top: 3px solid #6530d9;
  border-radius: 5px;
  box-shadow: #6530d947 1px 8px 11px 0px;
  border-radius: 5px;
`

export const WorkshopImage = styled.img`
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  max-width: 100%
`


export const StyledHeader = styled.h2`
  white-space: nowrap;
  justify-content: center;
  background: url("/assets/img/featured-activity.png") center center / contain no-repeat;
  color: white;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  text-align: center;
  padding: 10px;
  width: auto;
`
